import { render, staticRenderFns } from "./ReviewNotes.vue?vue&type=template&id=70d460ad&scoped=true"
import script from "./ReviewNotes.vue?vue&type=script&lang=js"
export * from "./ReviewNotes.vue?vue&type=script&lang=js"
import style0 from "./ReviewNotes.vue?vue&type=style&index=0&id=70d460ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d460ad",
  null
  
)

export default component.exports